/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { cloneObject } from "./hooks-helpers";
import { isStringNotEmpty, isObject } from "../utils/empty-exists";
import { useSimpliCity } from "./use-simplicity.js";

const useOrgSettings = function () {
    const { settings } = useSimpliCity();

    const getOrgSettingsAll = () => {
        if (!settings) {
            return undefined;
        }
        return cloneObject(settings);
    };

    const getOrgSettingsString = (key_name) => {
        if (isStringNotEmpty(key_name) && isObject(settings)) {
            return settings[key_name];
        }
    };

    const getOrgSettingsNumber = (key_name) => {
        const str = getOrgSettingsString(key_name);
        if (isStringNotEmpty(str)) {
            return Number(str).valueOf();
        } else {
            return false;
        }
    };

    const getOrgSettingsBoolean = (key_name) => {
        const str = getOrgSettingsString(key_name);
        if (isStringNotEmpty(str)) {
            // eslint-disable-next-line no-constant-binary-expression
            const value = str === "true" ?? false;
            return value;
        } else {
            return false;
        }
    };

    const getOrgSettingsDate = (key_name) => {
        const str = getOrgSettingsString(key_name);
        if (isStringNotEmpty(str)) {
            return new Date(str);
        }
    };

    return {
        getOrgSettingsAll,
        getOrgSettingsString,
        getOrgSettingsNumber,
        getOrgSettingsBoolean,
        getOrgSettingsDate,
    };
};

export { useOrgSettings };
